export const twitterInitialState = {
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    platform: 'news',
    hasPlatformAsParent: true,
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    hasIncludeExclude: false,
    filterType: 'include',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    platform: 'news',
    hasPlatformAsParent: true,
    hasIncludeExclude: true,
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
  contentTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both', // both or original or copy
    platform: 'twitter',
    hasPlatformAsParent: true,
    componentName: 'contentTypeFilter',
    translateKey: 'filter:contentType',
  },
};
